/**
 * Format API calendar dates (YYYY-MM-DD) without UTC day-shift.
 *
 * `new Date('2026-08-26')` is UTC midnight, which becomes the previous
 * local calendar day in US timezones when passed to toLocaleDateString().
 */
export function formatCalendarDate(
  value: string | Date | null | undefined,
  locales?: string | string[],
  options?: Intl.DateTimeFormatOptions
): string {
  if (value == null || value === '') return '';

  if (typeof value === 'string') {
    const dateOnly = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dateOnly) {
      const year = Number(dateOnly[1]);
      const month = Number(dateOnly[2]);
      const day = Number(dateOnly[3]);
      return new Date(year, month - 1, day).toLocaleDateString(locales, options);
    }
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString(locales, options);
}
